export const completionStyles={
    boxStyle:{ width: "100%", maxWidth: "calc(100% - 10px)" }
}